import React from 'react';
import Text from '../../../components/Text';
import Button from '../../../components/Button';

interface DeleteEmailModalProps {
    emailId: number;
    emailAddress: string;
    onConfirm: () => void;
    onCancel: () => void;
}

export const DeleteEmailModal: React.FC<DeleteEmailModalProps> = ({emailAddress, onConfirm, onCancel }) => {
    return (
        <div>
            <Text classes={'zr-mb-4'}>{`E-Mail von "${emailAddress}" wirklich löschen?`}</Text>
            <div className={'zr-d-flex zr-gap-2'}>
                <Button
                    hierarchy="primary"
                    text="Löschen"
                    fn={onConfirm}
                />
                <Button
                    hierarchy="secondary"
                    text="Abbrechen"
                    fn={onCancel}
                />
            </div>
        </div>
    );
};

